import XIcon from "@heroicons/react/outline/XIcon";
import React, { Fragment, useState } from "react";
import StandardTab from "./standardTab";
import StandardGroupTab from "./standardGroupTab";
import { ILiftOffGalaxyStandard } from "../../../../model/interface/liftOffGalaxyStandard";

interface StandardPopupProps {
  liftOffHeaderId: number;
  liftOffGalaxyId: number;
  orderNumber: number;
  showPopup: (show: boolean) => void;
  handleAddTopic: (data: Array<ILiftOffGalaxyStandard>) => void;
  availableStates: Array<number>;
  availableGrades: Array<number>;
  selectedContentId: number;
}

const StandardPopup = (props: StandardPopupProps) => {
  const tab = { Standard: 0, StandardGroup: 1 };
  const [selectedTab, setSelectedTab] = useState(tab.Standard);

  const handleTabSelection = (tab: number) => {
    setSelectedTab(tab);
  };
  return (
    <Fragment>
      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>
          <div className="inline-block w-full align-bottom bg-white px-4 pt-5 pb-8 text-left  shadow-xl transform transition-all sm:align-middle sm:max-w-[80%] sm:w-full sm:p-6">
            <div className=" flex justify-end">
              <button
                onClick={() => props.showPopup(false)}
                type="button"
                className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
              >
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            <div className={"border-b pb-6"}>
              <div className="col-span-8">
                <div className="flex items-center justify-between mb-8 mt-4">
                  <div className="bg-gray-100 w-full">
                    <button
                      className={` before:border-primary-color before:absolute before:w-full before:h-2 before:top-0 before:left-0 group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10
                    ${
                      selectedTab === tab.Standard
                        ? "text-gray-900 topBorder border border-b-0 bg-white before:border-t-2"
                        : "text-gray-500"
                    }
                    `}
                      type="button"
                      onClick={() => {
                        handleTabSelection(tab.Standard);
                      }}
                    >
                      Standard
                    </button>
                    <button
                      className={` before:border-primary-color before:absolute before:w-full before:h-2 before:top-0 before:left-0 group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10
                    ${
                      selectedTab === tab.StandardGroup
                        ? "text-gray-900 topBorder border border-b-0 bg-white before:border-t-2"
                        : "text-gray-500"
                    }
                    `}
                      type="button"
                      onClick={() => {
                        handleTabSelection(tab.StandardGroup);
                      }}
                    >
                      Standard Group
                    </button>
                  </div>
                </div>

                <div className="p-4 shadow -mt-8">
                  {selectedTab === tab.Standard && (
                    <StandardTab
                      liftOffHeaderId={props.liftOffHeaderId}
                      liftOffGalaxyId={props.liftOffGalaxyId}
                      orderNumber={props.orderNumber}
                      handleAddTopic={props.handleAddTopic}
                      availableStates={props.availableStates}
                      availableGrades={props.availableGrades}
                      selectedContentId={props.selectedContentId}
                    />
                  )}
                  {selectedTab === tab.StandardGroup && (
                    <StandardGroupTab
                      liftOffHeaderId={props.liftOffHeaderId}
                      liftOffGalaxyId={props.liftOffGalaxyId}
                      orderNumber={props.orderNumber}
                      handleAddTopic={props.handleAddTopic}
                      availableStates={props.availableStates}
                      availableGrades={props.availableGrades}
                      selectedContentId={props.selectedContentId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StandardPopup;
